/* All policy details remain readable when JavaScript is unavailable. */
(() => {
  const enhance = () => {
    document.querySelectorAll('.fp-returns__detail').forEach((detail, index) => {
      const title = detail.querySelector('.fp-returns__detail-title');
      const body = detail.querySelector('.fp-returns__detail-body');
      if (!title || !body || title.querySelector('button')) return;
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'fp-returns__detail-button';
      button.textContent = title.textContent;
      body.id = `fp-return-detail-${index + 1}`;
      button.setAttribute('aria-controls', body.id);
      const toggle = document.createElement('span');
      toggle.className = 'fp-returns__toggle';
      toggle.setAttribute('aria-hidden', 'true');
      button.append(toggle);
      const setOpen = open => {
        button.setAttribute('aria-expanded', String(open));
        body.hidden = !open;
      };
      button.addEventListener('click', () => setOpen(button.getAttribute('aria-expanded') !== 'true'));
      title.replaceChildren(button);
      setOpen(detail.classList.contains('fp-returns__detail--open'));
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', enhance, {once: true});
  else enhance();
})();
